import React from 'react'
import { CompanyLogo } from './Image'
import { CompanyProfile } from 'app/types/organization'
import { classNames } from 'app/utils/classes'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

/* This example requires Tailwind CSS v2.0+ */
type FooterProps = {
  isVenueLandingPage?: boolean
  organizationId?: string | string[]
  companyProfile?: CompanyProfile | null
}

function Footer({ companyProfile }: FooterProps) {
  const { t } = useTranslation('common')

  return (
    <React.Fragment>
      <footer
        style={{
          backgroundColor:
            companyProfile?.primary_main && companyProfile.primary_main,
        }}
        className="bg-blue-900 p-4 py-8 md:p-8 lg:p-10"
      >
        <div className="mx-auto max-w-screen-xl text-center">
          <div className="flex flex-col items-center justify-between gap-5  sm:flex-row sm:flex-nowrap sm:gap-0">
            <div className="h-10">
              <CompanyLogo imageLink={companyProfile?.logo ?? undefined} />
            </div>
            <div>
              <ul
                className={classNames(
                  companyProfile?.primary_inverted
                    ? 'text-gray-900 hover:text-black'
                    : 'text-gray-100 hover:text-white',
                  'mb-4 flex flex-wrap items-center text-sm lg:mb-0'
                )}
              >
                <li>
                  <Link href="/" className="mr-4 hover:underline md:mr-6 ">
                    {t('footer-liveday-link')}
                  </Link>
                </li>
                <li>
                  <Link href="/about" className="mr-4 hover:underline md:mr-6">
                    {t('footer-about-link')}
                  </Link>
                </li>
                <li>
                  <Link href="/terms_of_service" className="hover:underline">
                    {t('footer-terms-link')}
                  </Link>
                </li>
              </ul>
            </div>
            <div></div>
          </div>
          <hr
            style={{
              borderColor:
                companyProfile?.secondary_main && companyProfile.secondary_main,
            }}
            className="my-6 border-blue-600 sm:mx-auto"
          />
          <div className="sm:flex sm:items-center sm:justify-between">
            <span
              className={classNames(
                companyProfile?.primary_inverted
                  ? 'text-gray-900 hover:text-black'
                  : 'text-gray-100 hover:text-white',
                'block text-sm'
              )}
            >
              {t('footer-powered-by')}
              <a href="https://liveday.se" className="hover:underline">
                {' '}
                Liveday
              </a>
              .
            </span>
          </div>
        </div>
      </footer>
    </React.Fragment>
  )
}

export { Footer, type FooterProps }

// Extracted text strings:
// 'footer-success-message': 'Tack!'
// 'footer-success-subtitle': 'Du kommer nu få vårt nyhetsbrev.'
// 'footer-failure-message': 'Något gick fel'
// 'footer-failure-subtitle': 'Försök igen senare.'
// 'footer-liveday-link': 'Liveday.se'
// 'footer-about-link': 'Om Liveday'
// 'footer-terms-link': 'Användarvillkor'
// 'footer-email-label': 'Email address'
// 'footer-email-placeholder': 'Ange din e-mail'
// 'footer-subscribe-button': 'Prenumerera'
// 'footer-powered-by': 'Powered by'
